module.exports = __webpack_public_path__ + "static/media/fast.57661e31.png";